enum ReportMethod {
    Download = 1,
    Preview = 2,
    Print = 3
}

export default ReportMethod;